exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hide {\n  display: none !important;\n}\n/*.ver-facturaciones .ag-body-viewport .ag-pinned-left-cols-container,\n.ver-facturaciones .ag-header .ag-pinned-left-header {\n  display: none;\n}*/\n.hideuri {\n  width: 0px !important;\n}\n.ver-facturaciones .estilo-grilla {\n  height: auto !important;\n  margin-bottom: 50px;\n}\n.ver-facturaciones div[col-id='checked'] {\n  pointer-events: all !important;\n}\n", ""]);

// exports
